import { useFirestoreID } from '../../firebase/useFirestore'

const QuestionMeta = ({field, color}) => {

    const fields = useFirestoreID('QuestionnaireFields', field ? field : '')

    // AI-CONTEXT: See docs/pitfalls.md#state-firestore-lookup-empty-in-template-mode
    if(fields?.[0]?.Standard === 'true') {
      return (
        <></>
      )
    }

  return (
    <>
        {fields && fields.map(item => (
            <p style={{ color: color || 'black' }} key={item.ID}>{item.Question}</p>
        ))}
    </>
  )
}

export default QuestionMeta